import script from "./AdministratorProjectLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./AdministratorProjectLayout.vue?vue&type=script&setup=true&lang=js"

import "./AdministratorProjectLayout.vue?vue&type=style&index=0&id=5de64274&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5de64274"]])

export default __exports__